(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card-color-thumbnails"] && !Shopify.designMode) return;
  try {
    class ProductCardColorThumbnails extends HTMLElement {
    connectedCallback() {
      this.addEventListener('pointerover', this.handlePointerOver);
      this.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.removeEventListener('pointerover', this.handlePointerOver);
      this.removeEventListener('click', this.handleClick);
    }

    handlePointerOver = (event) => {
      if (event.pointerType !== 'mouse') return;

      const button = event.target.closest('[data-media-id]');
      if (button) this.selectThumbnail(button);
    };

    handleClick = (event) => {
      const button = event.target.closest('[data-media-id]');
      if (!button) return;

      event.preventDefault();
      event.stopPropagation();
      this.selectThumbnail(button);
    };

    selectThumbnail(button) {
      const mediaId = button.dataset.mediaId;
      const variantUrl = button.dataset.variantUrl;
      const productCard = this.closest('product-card');

      if (!mediaId || !variantUrl || typeof productCard?.previewVariant !== 'function') return;

      productCard.previewVariant(mediaId);

      for (const link of productCard.querySelectorAll(
        'a[ref="productCardLink"], a[ref="cardGalleryLink"], a[ref="productTitleLink"]'
      )) {
        link.href = variantUrl;
      }

      for (const thumbnail of this.querySelectorAll('[data-media-id]')) {
        thumbnail.setAttribute('aria-pressed', String(thumbnail === button));
      }
    }
  }

  if (!customElements.get('product-card-color-thumbnails')) {
    customElements.define('product-card-color-thumbnails', ProductCardColorThumbnails);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["size-order-guard"] && !Shopify.designMode) return;
  try {
    const configElement = document.getElementById('size-order-guard-config');
  const alertElement = document.getElementById('size-order-guard-alert');
  const allowedForms = new WeakSet();
  const productCache = new Map();
  let alertTimeout;

  const config = (() => {
    try {
      return JSON.parse(configElement?.textContent || '{}');
    } catch {
      return {};
    }
  })();

  const message =
    config.message ||
    'Dieses Kleidmodell befindet sich bereits in einer anderen Größe im Warenkorb. Bitte entferne zuerst die vorhandene Größe.';

  const normalize = (value) =>
    String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/ß/g, 'ss')
      .toLowerCase()
      .replace(/[^a-z0-9]/g, '');

  const sizeOptionIndex = (product) =>
    (product.options || []).findIndex((option) => {
      const name = normalize(typeof option === 'string' ? option : option.name);
      return name === 'size' || name.includes('grosse') || name.includes('groesse');
    });

  const productUrl = (value) => {
    const url = new URL(value, window.location.origin);
    url.search = '';
    url.hash = '';
    if (!url.pathname.endsWith('.js')) url.pathname = `${url.pathname.replace(/\/$/, '')}.js`;
    return url.toString();
  };

  const loadProduct = async (url) => {
    const endpoint = productUrl(url);
    if (!productCache.has(endpoint)) {
      productCache.set(
        endpoint,
        fetch(endpoint, { credentials: 'same-origin' }).then((response) => {
          if (!response.ok) throw new Error('Product data could not be loaded');
          return response.json();
        })
      );
    }
    return productCache.get(endpoint);
  };

  const loadCart = async () => {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${root}cart.js`, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) throw new Error('Cart data could not be loaded');
    return response.json();
  };

  const variantSize = (product, variantId) => {
    const index = sizeOptionIndex(product);
    if (index < 0) return null;
    const variant = (product.variants || []).find((item) => String(item.id) === String(variantId));
    return variant?.options?.[index] || null;
  };

  const showGlobalMessage = () => {
    if (!alertElement) return;
    window.clearTimeout(alertTimeout);
    alertElement.textContent = message;
    alertElement.hidden = false;
    alertElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    alertTimeout = window.setTimeout(() => {
      alertElement.hidden = true;
    }, 10000);
  };

  const showProductMessage = (component) => {
    const error = component.querySelector('[ref="addToCartTextError"]');
    const liveRegion = component.querySelector('[ref="liveRegion"]');

    if (!error) {
      showGlobalMessage();
      return;
    }

    let text = error.querySelector('[data-size-order-guard-message]');
    if (!text) {
      text = document.createElement('span');
      text.dataset.sizeOrderGuardMessage = '';
      error.appendChild(text);
    }

    text.textContent = message;
    error.classList.remove('hidden');
    error.setAttribute('aria-live', 'assertive');
    if (liveRegion) liveRegion.textContent = message;

    window.setTimeout(() => {
      error.classList.add('hidden');
      if (liveRegion?.textContent === message) liveRegion.textContent = '';
    }, 10000);
  };

  const conflictForSelection = async (component, variantId) => {
    const url = component.dataset.productUrl;
    const productId = component.dataset.productId;
    if (!url || !productId || !variantId) return false;

    const [cart, product] = await Promise.all([loadCart(), loadProduct(url)]);
    const selectedSize = variantSize(product, variantId);
    if (!selectedSize) return false;

    return (cart.items || []).some((item) => {
      if (String(item.product_id) !== String(productId)) return false;
      const existingSize = variantSize(product, item.variant_id);
      return existingSize && normalize(existingSize) !== normalize(selectedSize);
    });
  };

  const itemProductUrl = (item) => {
    if (item.url) return item.url.split('?')[0];
    const root = window.Shopify?.routes?.root || '/';
    return `${root}products/${item.handle}`;
  };

  const conflictInCart = async () => {
    const cart = await loadCart();
    const groups = new Map();

    for (const item of cart.items || []) {
      const key = String(item.product_id);
      if (!groups.has(key)) groups.set(key, []);
      groups.get(key).push(item);
    }

    for (const items of groups.values()) {
      if (items.length < 2) continue;
      const product = await loadProduct(itemProductUrl(items[0]));
      const sizes = new Set();

      for (const item of items) {
        const size = variantSize(product, item.variant_id);
        if (size) sizes.add(normalize(size));
      }

      if (sizes.size > 1) return true;
    }

    return false;
  };

  const setCheckoutState = (hasConflict) => {
    document.querySelectorAll('#checkout, [name="checkout"]').forEach((button) => {
      if (!(button instanceof HTMLButtonElement || button instanceof HTMLInputElement)) return;
      if (hasConflict) {
        button.dataset.sizeOrderGuardDisabled = '';
        button.disabled = true;
      } else if ('sizeOrderGuardDisabled' in button.dataset) {
        delete button.dataset.sizeOrderGuardDisabled;
        button.disabled = false;
      }
    });

    document.querySelectorAll('.additional-checkout-buttons').forEach((container) => {
      if (!(container instanceof HTMLElement)) return;
      if (hasConflict) {
        container.dataset.sizeOrderGuardHidden = '';
        container.hidden = true;
      } else if ('sizeOrderGuardHidden' in container.dataset) {
        delete container.dataset.sizeOrderGuardHidden;
        container.hidden = false;
      }
    });

    if (hasConflict) showGlobalMessage();
  };

  const refreshCheckoutState = async () => {
    try {
      setCheckoutState(await conflictInCart());
    } catch {
      setCheckoutState(false);
    }
  };

  document.addEventListener(
    'submit',
    async (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      const productComponent = form.closest('product-form-component');
      if (productComponent && form.matches('[data-type="add-to-cart-form"]')) {
        if (allowedForms.has(form)) {
          allowedForms.delete(form);
          return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();

        const variantId = new FormData(form).get('id');

        try {
          if (await conflictForSelection(productComponent, variantId)) {
            showProductMessage(productComponent);
            return;
          }
        } catch {
          allowedForms.add(form);
          form.requestSubmit(event.submitter || undefined);
          return;
        }

        allowedForms.add(form);
        form.requestSubmit(event.submitter || undefined);
        window.setTimeout(refreshCheckoutState, 1000);
        return;
      }

      const isCheckout = event.submitter?.matches?.('#checkout, [name="checkout"]');
      if (!isCheckout) return;

      if (allowedForms.has(form)) {
        allowedForms.delete(form);
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      try {
        if (await conflictInCart()) {
          setCheckoutState(true);
          return;
        }
      } catch {
        allowedForms.add(form);
        form.requestSubmit(event.submitter || undefined);
        return;
      }

      allowedForms.add(form);
      form.requestSubmit(event.submitter || undefined);
    },
    true
  );

  document.addEventListener('DOMContentLoaded', refreshCheckoutState);
  window.addEventListener('cart:add', () => window.setTimeout(refreshCheckoutState, 500));
  window.addEventListener('cart:update', () => window.setTimeout(refreshCheckoutState, 500));
  } catch(e) { console.error(e); }
})();

})();
